
import { Component, Prop, Vue } from 'vue-property-decorator';
import CommonBlockLine from '@/components/common/CommonBlockLine.vue';
import { STAT, URLVER } from '@/config/config';
import {
  formatName,
  formatRead,
  formatDate,
  pushBy2804,
  jumpReport,
  formatRating,
  changeRatingStyle,
  jumpTimeShare,
  formatTime,
  formatChg,
  formatManyChg,
} from '@/utils/tools';
import CommonRankNumber from '@/components/common/CommonRankNumber.vue';
@Component({
  components: {
    CommonBlockLine,
    CommonRankNumber,
  },
})
export default class IndustryReport extends Vue {
  @Prop() private item!: object;
  @Prop() private chart!: boolean;
  @Prop() private index!: number;
  @Prop() private deepReport!: boolean;
  formatName = formatName;
  formatRead = formatRead;
  formatDate = formatDate;
  formatRating = formatRating;
  formatChg = formatChg;
  formatManyChg = formatManyChg;
  changeListStyle(j: any) {
    if (j !== 0) {
      return {
        marginLeft: '0.16rem',
      };
    } else {
      return false;
    }
  }
  //研报跳转
  jumpReport(item: any) {
    item.pid && jumpReport(item.pid);
  }
  //点击头像跳转
  clickAvatar(item: any) {
    window.hxmPageStat(`${STAT.follow}.hyzy`, URLVER);
    if (item.secondIndustryType) {
      const param = {
        swCode: item.secondIndustryType,
        name: item.industry,
      };
      pushBy2804('/mainPage', param);
    }
  }
  formatTime(time: any) {
    const now = new Date();
    const publish = new Date(time.replace(new RegExp(/-/gm), '/'));
    const obj = {
      '-86400000': '昨日',
      '0': '今日',
    };
    return obj[publish.setHours(0, 0, 0, 0) - now.setHours(0, 0, 0, 0)] || formatTime(publish, 'yyyy-MM-dd');
  }
  jumpTitleReport(item: any) {
    window.hxmPageStat(`${STAT.follow}.title`, URLVER);
    item.pid && jumpReport(item.pid);
  }
  //点击头像跳转
  clickAvatarAuthor(item: any) {
    if (item.authorId) {
      const param = {
        authorId: item.authorId,
        name: item.author,
        org: item.orgName,
      };
      pushBy2804('/mainPage', param);
    }
  }
  //点击头像跳转
  clickAvatarOrg(item: any) {
    if (item.orgId) {
      const param = {
        orgId: item.orgId,
        name: item.orgName,
      };
      pushBy2804('/mainPage', param);
    }
  }
  //格式化cat数据
  formatCat(cat: any) {
    if (cat) {
      if (cat.indexOf('!') === -1) {
        return cat;
      } else {
        return cat.slice(0, cat.indexOf('!'));
      }
    } else {
      return false;
    }
  }
  //跳转分时
  jumpToFenshi(item: any) {
    window.hxmPageStat(`${STAT.follow}.ggfs`, URLVER);
    const params = {
      market: item.market,
      stockCode: item.stockCode || item.code,
    };
    jumpTimeShare(params);
  }
  //多个股票跳转分时
  jumpFenshi(item: any, j: number) {
    window.hxmPageStat(`${STAT.follow}.ggfs`, URLVER);
    const params = {
      market: null,
      stockCode: item.stockCode.split('!')[j],
    };
    jumpTimeShare(params);
  }
  changeStyle(item: any) {
    return changeRatingStyle(this.deepReport, item);
  }
}
